import styled from "styled-components";

export const StyledDiv = styled.div`
  padding: 0 1em;
`;
